import { useState } from "react";
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { StickyHeader } from "./templates/header_demo";
import Typography from '@material-ui/core/Typography';
import { StickyFooter } from "./templates/footer_demo";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {Box} from "@material-ui/core";
import {nestFlexStyle} from "../../../components/container";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
    siteContainer: {
        [theme.breakpoints.down('xs')]: {
            maxWidth: '444px'
        },
        [theme.breakpoints.up('sm')]: {
            maxWidth: 'calc(444px + 1rem)'
        },
        marginBottom: '5vh'
    }
}));

export const PageScrollingDemo = (props) => {
    const classes = useStyles();
    const [showCta, setShow] = useState(false);

    return (
        <div>
            <StickyHeader />
            <Container className={classes.siteContainer}>
                <Box style={nestFlexStyle} position="relative">
                    <Typography component="h1" variant="h5" gutterBottom>
                        Hello! Get started with your information
                    </Typography>
                    <form className={classes.form} style={nestFlexStyle}>
                        <TextField
                            id="fullName"
                            name="fullName"
                            label="Full Name"
                            placeholder="Full Name"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="preferredName"
                            name="preferredName"
                            label="Display Name"
                            placeholder="Display Name"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="email"
                            name="email"
                            label="Email"
                            placeholder="Email address"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="password"
                            name="password"
                            label="Password"
                            placeholder="Password"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="phoneNo"
                            name="phoneNo"
                            label="Phone Number"
                            placeholder="Phone Number"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="hkid"
                            name="hkid"
                            label="HKID"
                            placeholder="HKID"
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            id="dob"
                            name="dob"
                            label="Date of Birth (DD/MM/YY)"
                            placeholder="Date of Birth (DD/MM/YY)"
                            fullWidth
                            margin="normal"
                        />
                    </form>
                </Box>
            </Container>
            <StickyFooter>
                <Grid container spacing={10}>
                    <Grid item xs>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setShow(prev => !prev)}
                        >
                            Click to see 2 CTA
                        </Button>
                    </Grid>
                    {showCta && <Grid item>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Sign Up
                        </Button>
                    </Grid> }
                </Grid>
            </StickyFooter>
        </div>
    );
}


